export default __webpack_public_path__ + "static/media/NameSession.bbd79208.svg";